import Loading from 'src/DAIComponents/Common/Loading'
import useUnipileContext from 'src/hooks/useUnipileContext'
import { Provider } from '../SettingsTypes'
import { AppointmentSettingsFormComponent } from './AppointmentSettingsFormComponent'

export default function UnipileIntegrationSection() {
  const {
    isLoading,
    accountInfo,
    changeAccount,
    getAccountLink,
    selectedCalendarData,
    setCalendar,
    calendars,
    removeAccount,
    isRedirecting,
  } = useUnipileContext()

  if (isLoading || isRedirecting) {
    return <Loading full={true} />
  }

  return (
    <>
      <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 pt-2 pb-16 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <h2 className="text-base font-semibold leading-7 text-gray-900">
            Integrate your email provider.
          </h2>
          <p className="mt-1 text-sm leading-6 text-gray-400">
            This is how we send emails on your behalf, schedule appointments
            into your calendar, and more.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:max-w-xl sm:grid-cols-6">
            <div className="sm:col-span-3">
              <label
                htmlFor="first-name"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email Provider
              </label>
              <div className="mt-2">
                {!accountInfo?.isAuthorized && (
                  <p className="text-sm leading-6 text-gray-400">
                    No email provider connected.
                  </p>
                )}
                {accountInfo?.isAuthorized && (
                  <div className="flex items-center gap-x-4">
                    {accountInfo?.provider === Provider.google && (
                      <img
                        src={'/images/googleLogo.png'}
                        alt="Google Logo"
                        className="w-20 h-auto"
                      />
                    )}
                    {accountInfo?.provider === Provider.microsoft && (
                      <img
                        src={'/images/microsoftLogo.png'}
                        alt="Microsoft Logo"
                        className="w-20 h-auto"
                      />
                    )}
                    {accountInfo?.provider === Provider.imap && (
                      <span className="text-sm font-semibold text-gray-900">
                        IMAP
                      </span>
                    )}
                    <span className="text-sm font-semibold text-gray-900">
                      Connected
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="mt-8 flex">
            <button
              onClick={() => {
                if (accountInfo?.isAuthorized) {
                  changeAccount()
                } else {
                  getAccountLink()
                }
              }}
              type="button"
              className="mr-4 rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            >
              {!accountInfo?.isAuthorized && 'Connect Email Account'}
              {accountInfo?.isAuthorized && 'Change Email Account'}
            </button>
            {/*TODO - If accountInfo.isAuthorized is true, but has been disconnected, the button should say "Reconnect Email Account"*/}
            {accountInfo?.isAuthorized && (
              <button
                onClick={() => removeAccount()}
                type="button"
                className="rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              >
                Disconnect
              </button>
            )}
          </div>
        </div>
      </div>
      {accountInfo?.isAuthorized && (calendars?.length ?? 0) > 0 && (
        <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 sm:px-6 md:grid-cols-3 lg:px-8">
          <div>
            <h2 className="text-base font-semibold leading-7 text-gray-900">
              Appointment Settings
            </h2>
            <p className="mt-1 text-sm leading-6 text-gray-400">
              Choose your calendar and customize your scheduling preferences.
            </p>
          </div>

          <div className="md:col-span-2">
            <AppointmentSettingsFormComponent
              calendars={calendars ?? []}
              calendarData={selectedCalendarData}
              onSubmit={setCalendar}
            />
          </div>
        </div>
      )}
    </>
  )
}
